import { Component, OnInit, TemplateRef} from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { AdminService } from "../../../services/admin.service";
import { apiUrl } from "../../../global/global";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../../services/constants"
import swal from "sweetalert2";
import { ToastrService } from "ngx-toastr";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";

@Component({
  selector: "app-my-templates",
  templateUrl: "./my-templates.component.html",
  styleUrls: ["./my-templates.component.css"]
})
export class MyTemplatesComponent implements OnInit {
  allData:any=[];
  currentPage:number | undefined;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  //modal box
  modalRef?: BsModalRef;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  //form
  showError:boolean = false;
  form: FormGroup;
  temId:any
  title:any
  constructor(private modalService: BsModalService,public route: ActivatedRoute, private router: Router,private api: AdminService,private toastrService: ToastrService,private formBuilder: FormBuilder) { 
    this.form = this.formBuilder.group({
      id:[""],
      subject:["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(50)])],
      description:["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(2000)])],
      action:["",Validators.compose([Validators.required])],
    })
  }
  
  ngOnInit(): void {
    this.getAllCard();
  }

  getAllCard(){
    let params = new HttpParams(); 
    params = params.append("skip", this.pagination.skip.toString());
    params = params.append("limit", this.pagination.limit.toString());
    this.api.getData(apiUrl._getTemplate,params)
    .subscribe(async (res) => {
      this.pagination.totalItems = res.data.count; 
      this.allData = res.data.data;
    })
  }
  // ============= For Active Users
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getAllCard();
  }
  // view
  view(data,preview: TemplateRef<any>) { 
    this.temId=data
    console.log(data,"data");
    
    this.modalRef = this.modalService.show(
      preview,
      Object.assign({},this.config, { class: "modal-lg addModal" })
    ); 
  } 
  // open model
  open(add: TemplateRef<any>) {  
    this.title ="Add";
    this.form.reset(); 
    this.modalRef = this.modalService.show(
      add,
      Object.assign({},this.config, { class: "modal-lg addModal" })
    ); 
  } 
  // open model
  openModal(data,edit: TemplateRef<any>) {  
    this.title ="Edit";
    this.temId=data.id;
    if(this.temId){ 
      this.form.patchValue(data)
    } else{
      this.form.reset();
    }
    this.modalRef = this.modalService.show(
      edit,
      Object.assign({},this.config, { class: "modal-lg addModal" })
    ); 
  } 
  
  onSubmit(){
    if(this.form.valid){
      if(this.title =="Edit"){
        this.api.putData(apiUrl._getTemplate, this.removeEmptyFiled(this.form)).subscribe(res => {
          this.modalRef?.hide()
          this.form.reset()
          this.getAllCard(); 
        })  
      } else{   
        delete(this.form.value.id);
        this.api.postData(apiUrl._getTemplate, this.removeEmptyFiled(this.form)).subscribe(res => {
          this.modalRef?.hide()
          this.form.reset()
          this.getAllCard(); 
        })  
      }
    } else{
      this.showError= true
      setTimeout(() => {
        this.showError= false
      }, 1500);
    }
  }
  // delete
  deleteStatus(id){
    let text = "<p>Are you sure you want to delete this template?</p>";
      swal.fire({
        html: text,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#EF7E2B",
        cancelButtonColor: "#ffffff",
        confirmButtonText:"Yes",
        cancelButtonText: "No",
        reverseButtons: true,
        width: 500
      }).then((result) => {
        if (result.value) { 
          const data = {
            "id": id, 
          }
          this.api.deleteData(apiUrl._getTemplate, data).subscribe(res => {
          this.getAllCard();
          })
        }
      });
  }
// remove empty filed
removeEmptyFiled(form){
  const formValues = form.value;
  const formKeys = Object.keys(formValues);
  if (formKeys.length) {
    for (let i = 0; i < formKeys.length; i++) {
      if (
        formValues[formKeys[i]] == null ||
        formValues[formKeys[i]] == undefined ||
        formValues[formKeys[i]] == ""
      ) {
        delete formValues[formKeys[i]];
      }
    }
  }
  return formValues
}
}
